import React, { useEffect, useState } from 'react';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-0 left-0 w-full z-[999] bg-gradient-to-r from-[#1a1a1a] to-[#2a2a2a] border-t border-[#FF8C00]/30 shadow-[0_-4px_20px_rgba(0,0,0,0.3)] p-3 flex items-center justify-center gap-3 backdrop-blur-sm" data-id="element-235">
      <div className="hidden sm:block text-white text-[13px] font-semibold" data-id="element-236">
        🔥 Oferta limitada: <span className="text-[#FFD700]" data-id="element-237">12.99€</span>{' '}
        <span className="line-through text-gray-400 text-[11px]" data-id="element-238">87€</span>
      </div>
      <a href="https://kleoyshop.com/cart/add?id=52708878745928&quantity=1" onClick={() => {
      if ((window as any).fbq) {
        ;
        (window as any).fbq('track', 'AddToCart');
      }
    }} className="bg-gradient-to-br from-[#FF8C00] to-[#FFD700] text-white font-bold py-2.5 px-6 rounded-full text-[14px] uppercase tracking-wide shadow-[0_4px_15px_rgba(255,140,0,0.4)] hover:scale-105 transition-transform no-underline whitespace-nowrap" data-id="element-239">
        ¡QUIERO MI PACK AHORA!
      </a>
    </div>;
}